import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import Button from "../../common/Button";
import success from "../../../assets/agent/success.svg";
import fail from "../../../assets/agent/fail.svg";
import { useNewClient } from "./useNewClient";

const MobileNewClient = () => {
  const { t } = useTranslation();
  const {
    form,
    errors,
    charCount,
    isSubmitting,
    successModal,
    errorModal,
    id,
    handleChange,
    handleSubmit,
    closeSuccessModal,
    setErrorModal,
    MAX_CHARACTERS,
  } = useNewClient();

  const preferredLanguages = [
    { value: "es", label: "Spanish" },
    { value: "en", label: "English" },
  ];

  const field = (label, name, required = true) => (
    <div className="mb-3">
      <label className="block text-white text-xs font-bold mb-1">
        {label} {required && <span className="text-red-300">*</span>}
      </label>
      <input
        type="text"
        value={form[name]}
        onChange={(e) => handleChange(name, e.target.value)}
        className="w-full bg-white/10 text-white placeholder-white/50 text-sm rounded-lg px-3 py-2.5 border border-white/20"
      />
      {errors[name] && <p className="text-red-300 text-[10px] mt-1">{errors[name]}</p>}
    </div>
  );

  return (
    <div
      className="flex flex-col h-screen overflow-y-auto"
      style={{ background: "linear-gradient(-80deg, #051D42 20%, #0C469F 82%, #0D4AA8 100%)" }}
    >
      <AdminMobileTopbar title={t("client.newClient")} />

      <div className="flex-1 px-4 py-4">
        <p className="text-white/80 text-xs mb-4">{t("client.description")}</p>

        <div className="mb-3">
          <label className="block text-white text-xs font-bold mb-1">
            {t("client.preferredLangauge")} <span className="text-red-300">*</span>
          </label>
          <select
            value={form.preferredLanguage}
            onChange={(e) => handleChange("preferredLanguage", e.target.value)}
            className="w-full bg-white/10 text-white text-sm rounded-lg px-3 py-2.5 border border-white/20"
          >
            <option value="" className="text-primary">{t("button.selectOption")}</option>
            {preferredLanguages.map((opt) => (
              <option key={opt.value} value={opt.value} className="text-primary">
                {opt.label}
              </option>
            ))}
          </select>
          {errors.preferredLanguage && <p className="text-red-300 text-[10px] mt-1">{errors.preferredLanguage}</p>}
        </div>

        {field(t("client.company"), "company")}
        {field(t("client.product"), "product")}
        {field(t("client.address"), "address")}
        {field(t("client.urlCalendar"), "urlCalendar")}
        {field(t("client.contactPerson"), "contactPerson")}
        {field(t("client.contactPhone"), "contactPhone")}
        {field(t("client.contactEmail"), "contactEmail")}
        {field(t("client.secondaryEmail"), "secondaryEmail", false)}

        <div className="mb-4">
          <label className="block text-white text-xs font-bold mb-1">{t("client.script")}</label>
          <textarea
            value={form.script}
            onChange={(e) => handleChange("script", e.target.value)}
            rows={5}
            className="w-full bg-white/10 text-white text-sm rounded-lg px-3 py-2.5 border border-white/20"
          />
          <p className="text-white/60 text-[10px] mt-1">{charCount}/{MAX_CHARACTERS}</p>
          {errors.script && <p className="text-red-300 text-[10px] mt-1">{errors.script}</p>}
        </div>

        <button
          type="button"
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="w-full bg-secondary text-white text-sm font-extrabold rounded-xl py-3 disabled:opacity-70"
        >
          {isSubmitting ? t("button.loading") : t("button.register")}
        </button>
      </div>

      {successModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={success} alt="success" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-2">{t("admin.userConfirm.clientHead")}</p>
            <p className="text-secondary font-bold mb-2 text-sm">
              {form.company} {t("admin.userConfirm.with")} {id}
            </p>
            <p className="text-sm text-gray-500 mb-4">{t("admin.userConfirm.descClient")}</p>
            <Link to="/dashboard">
              <Button variant="primary" onClick={closeSuccessModal}>{t("admin.userConfirm.btn")}</Button>
            </Link>
          </div>
        </div>
      )}
      {errorModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={fail} alt="fail" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-2">{t("admin.userError.head")}</p>
            {errors.submit && <p className="text-sm text-gray-500 mb-4">{errors.submit}</p>}
            <Button variant="secondary" onClick={() => setErrorModal(false)}>{t("admin.userError.btn")}</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileNewClient;
